import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetFacilityRevenueForecastRequestDtoSchema = z.object({
  facilityId: z.string(),
  from: z.string(),
  to: z.string(),
});

const GetFacilityRevenueForecastResponseDtoSchema = z.object({
  actuals: z.array(
    z.object({
      month: z.string(),
      value: z.number(),
    })
  ),
  forecast: z.array(
    z.object({
      month: z.string(),
      value: z.number(),
    })
  ),
});

export type GetFacilityRevenueForecastRequestDto = z.infer<
  typeof _GetFacilityRevenueForecastRequestDtoSchema
>;

export type GetFacilityRevenueForecastResponseDto = z.infer<
  typeof GetFacilityRevenueForecastResponseDtoSchema
>;

export const getFacilityRevenueForecast = (
  params: GetFacilityRevenueForecastRequestDto,
  config: AxiosRequestConfig<GetFacilityRevenueForecastRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(`facilities/${facilityId}/revenue-forecast`, {
      params: restParams,
      ...config,
    })
    .then(responseContract(GetFacilityRevenueForecastResponseDtoSchema));
};
